import React, {useState, useEffect} from 'react';

import UserSideMenu from '../../menu/UserSideMenu';
import { axiosInstnace as Axios } from '../../util/util';
import { endPoints } from '../../config';
import { history } from '../../history/history';
import Header from '../common/HeaderAfterLogin';
import Pagination from '../admin/common/Pagination';
import ReactAudioPlayer from 'react-audio-player';
import ExcelPopup from './ExcelPopup';
import AudioDetails from './audioDetails';
import audioDetails from './audioDetails';

const AudioManagement= props =>{
    //Set initial state
    const [audioList, handleAudioManagementList] = useState([]);
    const [statusArray]= useState(["Uploaded", "Accepted", "Rejected"]);
    const [noDataClass, handleNoDataClass] = useState('none');
    const [dataClass, handleDataClass] = useState('none');
    const [count, handleCount]= useState(0);
    const [showExcelPopup, setShowHideExcelPopup]= useState(false);
    const [showAudioDetailsPopup, setShowHideAudioDetailsPopup]= useState(false);
    const [skip, handleSkip] = useState(0);
    const [audioHistory, handleAudioHistory] = useState(undefined);
    useEffect(() =>{
        getAudioManagementList(0)
        let loc = props;
    },[])

    //Fetching the audio management list
    const getAudioManagementList = async (skip,name) =>{
        handleSkip(skip);
        try {
            const data = await Axios.get(endPoints.getPreviousAudio,{
                params:{
                    skip,
                    userEmail: JSON.parse(localStorage.getItem('userInfo')).email,
                    name
                }
            });
            const result = data.data.data.data;
            if (result && result.length > 0) {
                handleAudioManagementList(result);
                handleNoDataClass('none');
                handleDataClass('');
                handleCount(data.data.data.count)
            }
            else if(result && result.length === 0 && name){
                handleAudioManagementList(result);
                handleNoDataClass('none');
                handleDataClass('')
            }
            else if(result && result.length === 0 && !name){
                handleNoDataClass('');
                handleDataClass('none')
            }

        } catch (error) {
            console.log(error);

        }
    }

    //searching the ampaign
    const getSearch = e =>{
        if(e.target.value.length >0){
            getAudioManagementList(0, e.target.value)
        }else{
            getAudioManagementList(0)
        }
    }

    const getAudioManagementDetail = data =>{
        props.getAudioManagementDetails(data);
        props.onSubmit();
    }

    const showHideExcelPopup= ()=> {
      setShowHideExcelPopup(!showExcelPopup)
     };

     const showHideAudioDetailsPopup = (a) => {
       console.log(a.target);
       handleAudioHistory(a);
       setShowHideAudioDetailsPopup(!showAudioDetailsPopup)
     }

    //Return the table that cantain Audio Management info
    return (
        <div className="main_wrapper">
          <UserSideMenu {...props} />
          <div className="dashboard_right_wrapper">
            <div className="right_wrapper_inner">
              <Header />
              <div className="dash_content_wrapper">
                <div className="content_wrapper_inner">
                  <div className={`camp_wrapper ${dataClass}`}>
                    <div className="running_cap_head">
                      <h2 className="camp_head">AUDIO MANAGEMENT</h2>
                      <div className="camp_right">
                        {/*<div className="search_name">
                          <span className="search_img"><img src="../../assets/images/search.png" /></span>
                          <input type="text" placeholder="Search here by Campaign Name" onChange={getSearch}/>
                        </div>
                        <div className="create_camp_btn">
                          <button onClick={()=>{ history.push({pathname:'/package'})}}>CREATE CAMPAIGN</button>
                        </div>*/}
                      </div>
                       {/* <div className="contact_submit">
                      <button >ADD</button>
                     </div> */}

                     <div className="print_btn">
                      <button onClick= {showHideExcelPopup}>ADD</button>
                       </div>
                    </div>


                    <div className="camp_listing_wrapper">
                      <table className="table table-striped master-table">
                        <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Audio Name</th>
                          <th>Audio File</th>
                          <th>Status</th>
                          <th>Audio</th>
                          <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        { audioList.map((a,i)=>  <tr key= {i}>
                          <td>{i+1}</td>
                          <td>{a.name}</td>
                          <td>{a.fileName}</td>
                         <td>
                          <select value = {a.status === 'Uploaded' ? 'New':a.status} readOnly
                                  className= {a.status== "Uploaded"? "status_select new": a.status=== "Approved"?
                                      "status_select audio_approved": "status_select ro_approved"}
                                  disabled= {a.status === ("Approved" || "Rejected")}>
                              {statusArray.map((audioState, index)=> (
                                  <option key= {index}>{audioState}</option>
                              ))}
                          </select>
                         </td>
                          <td>
                            <ReactAudioPlayer
                              src={`${process.env.DOMAIN}/${a.url}`}
                              controls
                              controlsList="nodownload"
                            />
                          </td>
                          <td><a className="view_list" onClick={showHideAudioDetailsPopup} >VIEW</a></td>
                        </tr>)}
                        </tbody>
                      </table>
                      <div className="paginationTable">
                          {(skip>0 || count>= 10 ) &&
                          <Pagination getAllData= {getAudioManagementList} totalRecords= {count}/>
                          }
                      </div>
                    </div>
                    {/* {showExcelPopup &&
                    <ExcelPopup hideExcelPopup= {showHideExcelPopup} />
                    } */}
                  </div>
                    {/* <div className="listing_footer">
                    <div className="listing_footer_left">
                    </div>
                    <div className="listing_footer_right">
                    </div>
                  </div> */}

                  <div className={`bookcampaign ${noDataClass}`}>
                    <div>
                      <img src="../../assets/images/radio.png" />
                    </div>
                    <div className="book_camp_para"><p>It seems like you don't have any audio's yet</p></div>
                    {/*<div className="book_camp_btn"><button onClick={()=>{
                        window.location.href='/package'}}>BOOK CAMPAIGNS</button></div>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showExcelPopup &&
           <ExcelPopup hideExcelPopup= {showHideExcelPopup} />

          }
          {showAudioDetailsPopup && 
            <AudioDetails 
            hideAudioDetailsPopup = {showHideAudioDetailsPopup}
            audioHistory = {audioHistory}
             />
          }
        </div>
    );
}
export default AudioManagement;


// WEBPACK FOOTER //
// ./web/components/audioManagement/audioManagementListComp.js